import { fork } from 'redux-saga/effects';

import { actions, selectors } from 'domain/item';
import { listNavigator } from 'sagas/common';
import filters from 'filters/item';

export default function* navigator() {
  yield fork(listNavigator, { modelName: 'Item', actions, selectors, filters } );
}
